<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-date-picker v-model="orderTime" type="daterange" range-separator=" - " :start-placeholder="$t('message.orderTimeStartHolder')" :end-placeholder="$t('message.orderTimeEndHolder')" value-format="yyyy-MM-dd"></el-date-picker>
        </div>
        <div class="search_btn" @click="searchMen">{{$t('message.searchBtnText')}}</div>
        <div class="search_btn" @click="exportExcel">{{$t('message.exportText')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="manList" :data="manList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="100"></el-table-column>
          <el-table-column :label="$t('message.deliveryManTitle')" prop="PostManName" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.deliveryNumTitle')" prop="PostNum" min-width="120"></el-table-column>
          <el-table-column :label="$t('message.menuText.deliveryDetailTitle')" width="200">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button class="operation_a_blue" @click.native.prevent="checkDetail(scope.row)">{{$t('message.orderTableCheckTitle')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDeliveryMen } from '@/api/getData.js'
  import exportTable from '@/js/exportExcel.js'
  export default {
    name: 'distributionStatistics',
    data () {
      return {
        orderTime: [],
        manList: []
      }
    },
    created() {
      this.getDeliveryMen()
    },
    methods: {
      // 查询配送员列表
      async getDeliveryMen (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
        let res = await getDeliveryMen(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        let index = 0
        this.manList = res.data.map(item => {
          item.index = ++index
          item.orderTime = this.orderTime
          return item
        })
      },
      // 搜索
      searchMen () {
        let param = {}
        if (this.orderTime && this.orderTime.length !== 0) {
          param.UGUDING6 = this.orderTime[0] + ' 00:00:00'
          param.DGUDING6 = this.orderTime[1] + ' 23:59:59'
        }
        this.getDeliveryMen(param)
      },
      checkDetail (obj) {
        this.$router.push({ path: '/deliveryDetail', query: { deliveryManId: obj.PostManId, orderTime: JSON.stringify(obj.orderTime) } })
      },
      // 导出表格
      exportExcel () {
        exportTable('#manList', this.$t('message.deliveryManTitle') + '.xlsx')
      },
    }
  }
</script>

<style scoped>
</style>
